import React, { useEffect, useState } from 'react';
import { Eye, ArrowLeftCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function ImpersonatingBanner() {
    const [active, setActive] = useState(false);
    const [email, setEmail] = useState('');

    useEffect(() => {
        const flag = localStorage.getItem('impersonating') === '1';
        setActive(flag);
        if (flag) {
            try {
                const u = JSON.parse(localStorage.getItem('user') || '{}');
                setEmail(u.email || '');
            } catch { /* ignore */ }
        }
    }, []);

    const stop = () => {
        const backup = localStorage.getItem('admin_token_backup');
        if (!backup) {
            toast.error('Admin token bulunamadı — yeniden giriş yap');
            return;
        }
        localStorage.setItem('token', backup);
        localStorage.removeItem('admin_token_backup');
        localStorage.removeItem('impersonating');
        localStorage.removeItem('user');
        localStorage.removeItem('company');
        toast.success('Süper admin oturumuna döndün');
        window.location.href = '/superadmin';
    };

    if (!active) return null;

    return (
        <div
            className="sticky top-0 z-[9999] bg-rose-700 text-white px-3 py-2 flex items-center justify-between gap-3 text-sm shadow-md"
            data-testid="impersonating-banner"
        >
            <div className="flex items-center gap-2 min-w-0">
                <Eye size={16} className="shrink-0" />
                <span className="truncate">
                    <b>Impersonating:</b> {email || 'kullanıcı'} olarak giriş yaptın. Bu kullanıcının tüm verilerini görüyorsun.
                </span>
            </div>
            <button
                onClick={stop}
                className="shrink-0 inline-flex items-center gap-1.5 bg-white text-rose-700 hover:bg-rose-50 font-bold px-3 py-1 rounded-md text-xs transition"
                data-testid="stop-impersonating-btn"
            >
                <ArrowLeftCircle size={14} /> Süper admine geri dön
            </button>
        </div>
    );
}
